<template>
  <div class="showImg">
    <img :src="getBase64(imgSrc)" preview />
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import Vue from "vue";
Vue.use(preview);
export default {
  mounted() {
    this.imgSrc = this.$route.params.imgSrc;
  },
  data() {
    return {
      imgSrc: "",
    };
  },
  methods: {
    getBase64(base64) {
      var changeBase64 =
        "data:image/png;base64," + base64.replace(/[\r\n]/g, "");
      // console.log(changeBase64);
      return changeBase64;
    },
  },
};
</script>

<style lang="scss" scoped>
.showImg {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 42.5rem;
    height: auto;
  }
}
</style>